export const businessRegistrationGetters = {
  businessRegistrationFormType: (state) => state.businessRegistrationFormType,
 
};
